<div class="pt-2" animate.enter="fade-in-enter" animate.leave="fade-in-leave">
  <div class="flex justify-between items-center pb-1">
    <p class="text-body bold">
      {{ guide().title | translate }}
    </p>
    @if (!guide().hideStepCount) {
      <p class="text-body text-neutral-70">
        {{ guide().guide.step }} {{ 'outlook.onboarding.of' | translate }}
        {{ guide().guide.total }}
      </p>
    }
  </div>
  <p class="text-body whitespace-pre-line">
    {{ guide().content | translate }}
  </p>
  <div class="flex justify-end items-center gap-2 mt-4">
    <button
      kendoButton
      tabindex="-1"
      themeColor="tertiary"
      id="outlook-onboarding-ui-step-guide-exit-{{ guide().stepId }}"
      (click)="exit.emit(guide().stepId)"
      class="text-body bold h-6"
    >
      {{ 'outlook.buttons.exit' | translate }}
    </button>
    <button
      kendoButton
      tabindex="-1"
      themeColor="primary"
      class="text-body bold h-6"
      (click)="next.emit(onboardingStep())"
    >
      {{ guide().button ?? 'outlook.buttons.next' | translate }}
    </button>
  </div>
</div>
